var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtensionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53033 11.7803C8.23744 12.0732 7.76256 12.0732 7.46967 11.7803L4.96967 9.28033C4.67678 8.98744 4.67678 8.51256 4.96967 8.21967C5.26256 7.92678 5.73744 7.92678 6.03033 8.21967L7.25 9.43934L7.25 1.75C7.25 1.33579 7.58579 1 8 1C8.41421 1 8.75 1.33579 8.75 1.75L8.75 9.43934L9.96967 8.21967C10.2626 7.92678 10.7374 7.92678 11.0303 8.21967C11.3232 8.51256 11.3232 8.98744 11.0303 9.28033L8.53033 11.7803ZM4.25 4.00002C4.66421 4.00002 5 4.3358 5 4.75002C5 5.16423 4.66421 5.50002 4.25 5.50002H4C3.17157 5.50002 2.5 6.17159 2.5 7.00002V12C2.5 12.8284 3.17157 13.5 4 13.5H12C12.8284 13.5 13.5 12.8284 13.5 12V7.00002C13.5 6.17159 12.8284 5.50002 12 5.50002H11.75C11.3358 5.50002 11 5.16423 11 4.75002C11 4.3358 11.3358 4.00002 11.75 4.00002H12C13.6569 4.00002 15 5.34316 15 7.00002V12C15 13.6569 13.6569 15 12 15H4C2.34315 15 1 13.6569 1 12V7.00002C1 5.34316 2.34315 4.00002 4 4.00002H4.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionIcon);
export default __webpack_public_path__ + "static/media/ExtensionIcon.d76349a14fc37a0813ae005d7d08a5d7.svg";
export { ForwardRef as ReactComponent };